// extracted by mini-css-extract-plugin
module.exports = {"page-background":"_2v3yk","pageBackground":"_2v3yk"};